module.exports = __webpack_public_path__ + "img/ic_bolt_purple_24dp.56e955fb.png";